import {
    Center,
    Table,
    TableContainer,
    Tbody,
    Text,
    Th,
    Thead,
    Tr,
} from "@chakra-ui/react";
import ScheduleSection from "pages/DrawSchedule/elements/ScheduleSection";

const DrawTable = ({ sections }: { sections: any }) => {
    return Object.keys(sections).length > 0 ? (
        <TableContainer>
            <Table variant="simple">
                <Thead>
                    <Tr>
                        <Th>Draw Title</Th>
                        <Th>Due Date</Th>
                        <Th>Status</Th>
                        <Th>Total Amount</Th>
                        <Th></Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {Object.keys(sections).map((section) => (
                        <ScheduleSection
                            key={section}
                            section={parseInt(section)}
                            items={sections[parseInt(section)]}
                        />
                    ))}
                </Tbody>
            </Table>
        </TableContainer>
    ) : (
        <Center flexDirection="column" h="300px">
            <Text fontSize="13px">
                A draw schedule has not been started for this loan.
            </Text>
        </Center>
    );
};
export default DrawTable;
